import type { SwipeTranslationQuestions } from '@lotta/shared/types-lottery-schemas';

/**
 * The data for generating questions template file for Swipe contest
 * for different markets supported by Lotta
 *
 * The data need to be updated for each new language when onboarding new markets.
 * Updating questions template should be included in onboarding process. To simplify
 * onboarding we are considering to move the template to database.
 */
export const swipeQuestionsTemplateData: Record<string, SwipeTranslationQuestions> = {
  sv: [
    {
      question: 'Ikea grundades 1945 i Älmhult.',
      description: 'Ikea grundades 1943 i Älmhult av Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Du har rätt.',
      wrongAnswerText: 'Du har fel.',
    },
    {
      question: 'Billy bokhyllan är IKEAs mest sålda produkt.',
      description: 'Billy bokhylla är en klassiker och har sålts i miljoner exemplar världen över.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Du har rätt.',
      wrongAnswerText: 'Du har fel.',
    },
  ],
  de: [
    {
      question: 'Ikea wurde 1945 in Älmhult gegründet.',
      description: 'Ikea wurde 1943 in Älmhult von Ingvar Kamprad gegründet.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Du hast Recht.',
      wrongAnswerText: 'Sie liegen falsch.',
    },
    {
      question: 'Das Billy-Bücherregal ist das meistverkaufte Produkt von IKEA.',
      description:
        'Das Billy-Bücherregal ist ein Klassiker und wurde weltweit millionenfach verkauft.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Du hast Recht.',
      wrongAnswerText: 'Sie liegen falsch.',
    },
  ],
  en: [
    {
      question: 'Ikea was founded in 1945 in Älmhult.',
      description: 'Ikea was founded in 1943 in Älmhult by Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'You are right.',
      wrongAnswerText: 'You are wrong.',
    },
    {
      question: "The Billy bookshelf is IKEA's best-selling product.",
      description: 'The Billy bookcase is a classic and has sold millions of copies worldwide.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'You are right.',
      wrongAnswerText: 'You are wrong.',
    },
  ],
  fi: [
    {
      question: 'Ikea perustettiin vuonna 1945 Älmhultissa.',
      description: 'Ingvar Kamprad perusti Ikean vuonna 1943 Älmhultissa',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Olet oikeassa.',
      wrongAnswerText: 'Olet väärässä.',
    },
    {
      question: 'Billy-kirjahylly on IKEA:n myydyin tuote.',
      description:
        'Billy-kirjahylly on klassikko, ja sitä on myyty miljoonia kappaleita maailmanlaajuisesti.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Olet oikeassa.',
      wrongAnswerText: 'Olet väärässä.',
    },
  ],
  fr: [
    {
      question: 'Ikea a été fondée en 1945 à Älmhult.',
      description: 'Ikea a été fondée en 1943 à Älmhult par Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Tu as raison.',
      wrongAnswerText: 'Vous avez tort.',
    },
    {
      question: "La bibliothèque Billy est le produit le plus vendu d'IKEA.",
      description:
        "La bibliothèque Billy est un classique et s'est vendue à des millions d'exemplaires dans le monde.",
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Tu as raison.',
      wrongAnswerText: 'Vous avez tort.',
    },
  ],
  nl: [
    {
      question: 'Ikea werd in 1945 opgericht in Älmhult.',
      description: 'Ikea werd in 1943 in Älmhult opgericht door Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Je hebt gelijk.',
      wrongAnswerText: 'Je hebt het mis.',
    },
    {
      question: 'De Billy boekenplank is het best verkochte product van IKEA.',
      description:
        'De Billy-boekenkast is een klassieker en er zijn wereldwijd miljoenen exemplaren van verkocht.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Je hebt gelijk.',
      wrongAnswerText: 'Je hebt het mis.',
    },
  ],
  it: [
    {
      question: 'Ikea è stata fondata nel 1945 ad Älmhult.',
      description: 'Ikea è stata fondata nel 1943 ad Älmhult da Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Hai ragione.',
      wrongAnswerText: 'Tui hai torto.',
    },
    {
      question: 'La libreria Billy è il prodotto più venduto di IKEA.',
      description:
        'La libreria Billy è un classico e ha venduto milioni di copie in tutto il mondo.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Hai ragione.',
      wrongAnswerText: 'Tui hai torto.',
    },
  ],
  da: [
    {
      question: 'Ikea blev grundlagt i 1945 i Älmhult.',
      description: 'Ikea blev grundlagt i 1943 i Älmhult af Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Du har ret.',
      wrongAnswerText: 'Du tager fejl.',
    },
    {
      question: 'Billy reolen er IKEAs bedst sælgende produkt.',
      description:
        'Billy reolen er en klassiker og har solgt millioner af eksemplarer verden over.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Du har ret.',
      wrongAnswerText: 'Du tager fejl.',
    },
  ],
  cs: [
    {
      question: 'Ikea byla založena v roce 1945 v Älmhultu.',
      description: 'Společnost Ikea byla založena v roce 1943 v Älmhultu Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Máte pravdu.',
      wrongAnswerText: 'Mýlíte se.',
    },
    {
      question: 'Knihovna Billy je nejprodávanějším produktem IKEA.',
      description: 'Knihovna Billy je klasika a po celém světě se jí prodaly miliony výtisků.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Máte pravdu.',
      wrongAnswerText: 'Mýlíte se.',
    },
  ],
  es: [
    {
      question: 'Ikea fue fundada en 1945 en Älmhult.',
      description: 'Ikea fue fundada en 1943 en Älmhult por Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Tienes razón.',
      wrongAnswerText: 'Está usted equivocado.',
    },
    {
      question: 'La estantería Billy es el producto más vendido de IKEA.',
      description:
        'La librería Billy es un clásico y ha vendido millones de copias en todo el mundo.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Tienes razón.',
      wrongAnswerText: 'Está usted equivocado.',
    },
  ],
  eu: [
    {
      question: 'Ikea 1945ean sortu zen Älmhult-en.',
      description: 'Ikea 1943an sortu zuen Älmhult-en Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Arrazoia duzu.',
      wrongAnswerText: 'Oker zaude.',
    },
    {
      question: 'Billy apalategia IKEAren produkturik salduena da.',
      description: 'Billy liburutegia klasiko bat da eta milioika ale saldu ditu mundu osoan.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Arrazoia duzu.',
      wrongAnswerText: 'Oker zaude.',
    },
  ],
  ca: [
    {
      question: "Ikea es va fundar l'any 1945 a Älmhult.",
      description: "Ikea va ser fundada l'any 1943 a Älmhult per Ingvar Kamprad.",
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Tens raó.',
      wrongAnswerText: "T'equivoques.",
    },
    {
      question: "La prestatgeria Billy és el producte més venut d'IKEA.",
      description: 'La llibreria Billy és un clàssic i ha venut milions de còpies a tot el món.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Tens raó.',
      wrongAnswerText: "T'equivoques.",
    },
  ],
  gl: [
    {
      question: 'Ikea foi fundada en 1945 en Älmhult.',
      description: 'Ikea foi fundada en 1943 en Älmhult por Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Tes razón.',
      wrongAnswerText: 'Estás equivocado.',
    },
    {
      question: 'A estantería Billy é o produto máis vendido de IKEA.',
      description: 'A estantería Billy é un clásico e vendeu millóns de copias en todo o mundo.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Tes razón.',
      wrongAnswerText: 'Estás equivocado.',
    },
  ],
  hr: [
    {
      question: 'Ikea je osnovana 1945. u Älmhultu.',
      description: 'Ikeu je 1943. u Älmhultu osnovao Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Vi ste u pravu.',
      wrongAnswerText: 'Vi niste u pravu.',
    },
    {
      question: 'Polica za knjige Billy najprodavaniji je IKEA-in proizvod.',
      description:
        'Billy polica za knjige je klasik i prodana je u milijunima primjeraka diljem svijeta',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Vi ste u pravu.',
      wrongAnswerText: 'Vi niste u pravu.',
    },
  ],
  hu: [
    {
      question: 'Az Ikeát 1945-ben alapították Älmhultban.',
      description: 'Az Ikeát 1943-ban Ingvar Kamprad alapította Älmhultban.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Igaza van.',
      wrongAnswerText: 'Téved.',
    },
    {
      question: 'A Billy könyvespolc az IKEA legkelendőbb terméke.',
      description:
        'A Billy könyvespolc klasszikus, és több millió példányban kelt el belőle világszerte.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Igaza van.',
      wrongAnswerText: 'Téved.',
    },
  ],
  ja: [
    {
      question: 'イケアは 1945 年にエルムフルトで設立されました。',
      description:
        'イケアは 1943 年にイングヴァル カンプラードによってエルムフルトで設立されました。',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'あなたが正しいです。',
      wrongAnswerText: 'あなたは間違っている。',
    },
    {
      question: 'ビリー本棚はIKEAのベストセラー商品です。',
      description: 'ビリー本棚は古典的であり、世界中で何百万部も販売されています。',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'あなたが正しいです。',
      wrongAnswerText: 'あなたは間違っている。',
    },
  ],
  ko: [
    {
      question: '이케아는 1945년 엘름훌트에서 설립되었습니다.',
      description:
        '이케아는 1943년 잉바르 캄프라드(Ingvar Kamprad)에 의해 엘름훌트에서 설립되었습니다.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: '당신 말이 맞아요.',
      wrongAnswerText: '당신은 틀렸습니다.',
    },
    {
      question: 'Billy 책장은 IKEA의 베스트셀러 제품입니다.',
      description: 'Billy 책장은 고전이며 전 세계적으로 수백만 권이 판매되었습니다.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: '당신 말이 맞아요.',
      wrongAnswerText: '당신은 틀렸습니다.',
    },
  ],
  no: [
    {
      question: 'Ikea ble grunnlagt i 1945 i Älmhult.',
      description: 'Ikea ble grunnlagt i 1943 i Älmhult av Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Du har rett.',
      wrongAnswerText: 'Du tar feil.',
    },
    {
      question: 'Billy bokhylle er IKEAs bestselgende produkt.',
      description:
        'Billy bokhylle er en klassiker og har solgt millioner av eksemplarer over hele verden.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Du har rett.',
      wrongAnswerText: 'Du tar feil.',
    },
  ],
  pl: [
    {
      question: 'Ikea została założona w 1945 roku w Ęlmhult.',
      description: 'Ikea została założona w 1943 roku w Ęlmhult przez Ingvara Kamprada.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Masz rację.',
      wrongAnswerText: 'Mylisz się.',
    },
    {
      question: 'Regał Billy to najlepiej sprzedający się produkt IKEA.',
      description:
        'Regał Billy to klasyk, który sprzedał się w milionach egzemplarzy na całym świecie.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Masz rację.',
      wrongAnswerText: 'Mylisz się.',
    },
  ],
  pt: [
    {
      question: 'A Ikea foi fundada em 1945 em Älmhult.',
      description: 'A Ikea foi fundada em 1943 em Älmhult por Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Você tem razão.',
      wrongAnswerText: 'Está errado.',
    },
    {
      question: 'A estante Billy é o produto mais vendido da IKEA.',
      description:
        'A estante Billy é um clássico e já vendeu milhões de exemplares em todo o mundo.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Você tem razão.',
      wrongAnswerText: 'Está errado.',
    },
  ],
  ro: [
    {
      question: 'Ikea a fost fondată în 1945 în Älmhult.',
      description: 'Ikea a fost fondată în 1943 în Älmhult de către Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Aveţi dreptate.',
      wrongAnswerText: 'Nu aveți dreptate.',
    },
    {
      question: 'Raftul Billy este cel mai bine vândut produs de la IKEA.',
      description:
        'Biblioteca Billy este un clasic și s-a vândut în milioane de exemplare în întreaga lume.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Aveţi dreptate.',
      wrongAnswerText: 'Nu aveți dreptate.',
    },
  ],
  sr: [
    {
      question: 'Ikea je osnovana 1945. godine u Almhultu.',
      description: 'Ikeu je 1943. godine u Almhultu osnovao Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'U pravu si.',
      wrongAnswerText: 'Grešiš.',
    },
    {
      question: 'Billi polica za knjige je IKEA-in najprodavaniji proizvod.',
      description:
        'Bili polica za knjige je klasična i prodata je u milionima primeraka širom sveta.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'U pravu si.',
      wrongAnswerText: 'Grešiš.',
    },
  ],
  sl: [
    {
      question: 'Ikea je bila ustanovljena leta 1945 v Älmhultu.',
      description: 'Ikeo je leta 1943 v Älmhultu ustanovil Ingvar Kamprad.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Imaš prav.',
      wrongAnswerText: 'Motiš se.',
    },
    {
      question: 'Knjižna polica Billy je najbolje prodajan izdelek IKEA.',
      description:
        'Knjižna omara Billy je klasika in je bila prodana v milijonih izvodov po vsem svetu.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Imaš prav.',
      wrongAnswerText: 'Motiš se.',
    },
  ],
  sk: [
    {
      question: 'Ikea bola založená v roku 1945 v Älmhult.',
      description: 'Ikea bola založená v roku 1943 v Älmhult Ingvarom Kampradom.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Máš pravdu.',
      wrongAnswerText: 'Mýliš sa.',
    },
    {
      question: 'Knižnica Billy je najpredávanejším produktom IKEA.',
      description: 'Knižnica Billy je klasika a po celom svete sa jej predali milióny kópií.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Máš pravdu.',
      wrongAnswerText: 'Mýliš sa.',
    },
  ],
  uk: [
    {
      question: 'Ikea bula zasnovana v 1945 rotsi v Elʹmkhulʹti.',
      description: 'Ikea bula zasnovana v 1943 rotsi v Elʹmkhulʹti Inhvarom Kampradom.',
      answer: false,
      image:
        'https://www.ikea.com/ext/ingkadam/m/4dfab13e21204124/webimage-ikea-ingvar-kamprad-white-oglan-chair-1965.png?f=xs',
      correctAnswerText: 'Vy mayete ratsiyu.',
      wrongAnswerText: 'Vy pomylyayetesʹ.',
    },
    {
      question: 'Knyzhkova polytsya Billy ye naybilʹsh prodavanym produktom IKEA.',
      description:
        'Knyzhkova shafa Billy ye klasykoyu i prodana milʹyonamy prymirnykiv po vsʹomu svitu.',
      answer: true,
      image: 'https://www.ikea.com/ext/ingkadam/m/1c8931cf5ffcd6cf/original/PE714279.jpg?f=xs',
      correctAnswerText: 'Vy mayete ratsiyu.',
      wrongAnswerText: 'Vy pomylyayetesʹ.',
    },
  ],
};
